const certifications = [
  {
    title: {
      en: "Generative AI & AI Fundamentals",
      ar: "أساسيات الذكاء الاصطناعي والذكاء الاصطناعي التوليدي",
    },
    issuer: {
      en: "Microsoft · LinkedIn · PMI",
      ar: "مايكروسوفت · لينكد إن · PMI",
    },
    date: {
      en: "Oct – Dec 2024",
      ar: "أكتوبر – ديسمبر 2024",
    },
    skills: ["Generative AI", "Responsible AI", "AI for Business"],
    includes: {
      en: [
        "Career Essentials in Generative AI",
        "What Is Generative AI?",
        "Ethics in the Age of Generative AI",
      ],
      ar: [
        "أساسيات المسار المهني في الذكاء الاصطناعي التوليدي",
        "ما هو الذكاء الاصطناعي التوليدي؟",
        "الأخلاقيات في عصر الذكاء الاصطناعي التوليدي",
      ],
    },
  },
  {
    title: {
      en: "Microsoft Copilot & AI Productivity",
      ar: "مايكروسوفت كوبايلت وإنتاجية الذكاء الاصطناعي",
    },
    issuer: {
      en: "LinkedIn",
      ar: "لينكد إن",
    },
    date: {
      en: "Oct 2024",
      ar: "أكتوبر 2024",
    },
    skills: ["Microsoft Copilot", "Microsoft 365", "AI Productivity"],
    includes: {
      en: [
        "Learning Microsoft 365 Copilot",
        "Streamlining Your Work with Microsoft Copilot",
      ],
      ar: [
        "تعلم Microsoft 365 Copilot",
        "تبسيط عملك باستخدام Microsoft Copilot",
      ],
    },
  },
  {
    title: {
      en: "Frontend Development: React & JavaScript",
      ar: "تطوير الواجهات الأمامية: React و JavaScript",
    },
    issuer: {
      en: "LinkedIn · Meta · OpenClassrooms",
      ar: "لينكد إن · ميتا · OpenClassrooms",
    },
    date: {
      en: "Jun 2023 – Dec 2024",
      ar: "يونيو 2023 – ديسمبر 2024",
    },
    skills: ["React.js", "JavaScript", "Redux Toolkit"],
    includes: {
      en: [
        "Hands-On Introduction: React",
        "Advanced React",
        "Coding Exercises: React.js",
      ],
      ar: [
        "مقدمة عملية: React",
        "مستوى متقدم: React",
        "تمارين برمجية: React.js",
      ],
    },
  },
  {
    title: {
      en: "Databases, APIs & Dev Tools",
      ar: "قواعد البيانات، والـ APIs وأدوات المطورين",
    },
    issuer: {
      en: "IBM · LinkedIn · MaharaTech",
      ar: "IBM · لينكد إن · مهارة تك",
    },
    date: {
      en: "May 2023 – Sep 2024",
      ar: "مايو 2023 – سبتمبر 2024",
    },
    skills: ["MongoDB", "Docker", "Git", "Postman"],
    includes: {
      en: ["MongoDB", "Git & GitHub", "Docker", "Postman"],
      ar: ["MongoDB", "Git & GitHub", "Docker", "Postman"],
    },
  },
];

export default certifications;
